var map = {
	"./basicSetting/assets/svg/dashboard.svg": "1291",
	"./budgetActivity/assets/svg/dashboard.svg": "689a",
	"./common/assets/svg/dashboard.svg": "828c",
	"./community/assets/svg/dashboard.svg": "b91b",
	"./dataAnalysis/assets/svg/dashboard.svg": "d117",
	"./external/assets/svg/dashboard.svg": "d8d6",
	"./externalMat/assets/svg/dashboard.svg": "3d9a",
	"./home/assets/svg/dashboard.svg": "cbe0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bfc0";